import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'

import App from './App.vue'
import router from './router'
import './styles/global.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
// 全量引入 Element Plus：后台系统对体积不敏感，
// 省掉 unplugin 自动导入那层构建魔法，排查问题更直接
app.use(ElementPlus, { locale: zhCn })

app.mount('#app')
